export const projectsCuisinesData = {
  project1: {
    title: "Project 01 — Baie des Anges, Tunisie",
    description: `
      Un espace multifonctionnel structuré par un contraste élégant entre le chanvre 
mat et la profondeur du bois Caraganna foncé, adouci par un grès noir aux 
veinures dorées qui crée une transition harmonieuse.
Le jeu entre opacité et transparence se révèle à travers les colonnes vitrées, 
encadrées d'aluminium noir, apportant légèreté et rythme à l'ensemble. Une 
touche de LED vient sublimer les matières et souligner les lignes, pour une 
ambiance à la fois moderne et chaleureuse 
    `,
    finishes: [
      { label: "C", name: "chanvre Matt" },
      { label: "C", name: "caragana" },
      { label: "G", name: "GRES NOIR DESIR" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-9.jpg",
      "gallery-17.jpg",
      "gallery-2.jpg",
      "gallery-10.jpg",
      "gallery-3.jpg",
      "gallery-11.jpg",
      "gallery-4.jpg",
      "gallery-12.jpg",
      "gallery-5.jpg",
      "gallery-13.jpg",
      "gallery-6.jpg",
      "gallery-14.jpg",
      "gallery-7.jpg",
      "gallery-15.jpg",
      "gallery-8.jpg",
      "gallery-16.jpg",
      "project1-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },

  project2: {
    title: "Project 02 — Chaffar, Tunisie",
    description: `
    Un espace au caractère affirmé, sublimé par un grès aux nuances de vert et à la 
texture marbrée profonde, qui capte la lumière et apporte une richesse visuelle 
remarquable. 
Les façades noires brillantes, associées à des vitrines encadrées d'un doré 
champagne délicat, créent un jeu de reflets élégant et sophistiqué, tout en 
structurant l'ensemble avec finesse. 
Ce mélange de matériaux lumineux et contrastés confère à la conception une 
véritable signature luxueuse, où modernité et raffinement s'expriment dans un 
équilibre harmonieux.
    `,
    finishes: [
      { label: "N", name: "NOIR BRILLANT" },
      { label: "G", name: "GRES VERDE FRANCE" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-9.jpg",
      "gallery-2.jpg",
      "gallery-10.jpg",
      "gallery-3.jpg",
      "gallery-11.jpg",
      "gallery-4.jpg",
      "gallery-12.jpg",
      "gallery-5.jpg",
      "gallery-6.jpg",
      "gallery-7.jpg",
      "gallery-8.jpg",
      "project2-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },

  project3: {
    title: "Project 03 — Hergla, Tunisie",
    description: `
      Une conception grandiose articulée autour de la centralité des éléments hauts 
et de l'îlot, véritables points focaux de l'espace. Les façades en verre fumé gris 
apportent un jeu de reflets subtil et sophistiqué, renforçant la profondeur 
visuelle.
Le grès, très graphique, se distingue par de larges formes géométriques qui 
insufflent caractère et modernité à l'ensemble. En contraste, des colonnes de 
rangement épurées en blanc brillant viennent adoucir la composition, apportant 
équilibre, luminosité et élégance.
    `,
    finishes: [
      { label: "B", name: "BLANC BRILLANT" },
      { label: "G", name: "GRES MAGELLANO" },
      { label: "C", name: "Chene brown" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-9.jpg",
      "gallery-2.jpg",
      "gallery-10.jpg",
      "gallery-3.jpg",
      "gallery-11.jpg",
      "gallery-4.jpg",
      "gallery-12.jpg",
      "gallery-5.jpg",
      "gallery-13.jpg",
      "gallery-6.jpg",
      "gallery-7.jpg",
      "gallery-8.jpg",
      "project3-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project4: {
    title: "Project 04 — Sfax, Tunisie",
    description: `
      Tout le charme de cette cuisine repose sur l'élégance du noir mat, associé à la 
texture du grès effet pierre qui apporte authenticité et relief. Le bois foncé vient 
subtilement souligner l'espace, renforçant sa profondeur et lui conférant 
davantage de caractère. L'ensemble crée une ambiance raffinée et 
chaleureuse, où les matières se complètent pour offrir une composition à la fois 
sobre, moderne et intemporelle.
    `,
    finishes: [
      { label: "G", name: "Gris matt" },
      { label: "C", name: "chene brown" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-7.jpg",
      "gallery-2.jpg",
      "gallery-3.jpg",
      "gallery-4.jpg",
      "gallery-5.jpg",
      "gallery-6.jpg",
      "project4-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project5: {
    title: "Project 05 — Tunis, Tunisie",
    description: `
      Une cuisine moderne et élégante, marquée par une continuité fluide du vitrage 
entre les colonnes et les meubles hauts, créant un encadrement harmonieux et 
structurant l'ensemble de la composition.
L'îlot central en grès sombre, aux veinures fines, apporte du caractère et 
devient le point focal, tandis que l'éclairage intégré aux vitrines souligne cette 
linéarité et instaure une ambiance chaleureuse.
    `,
    finishes: [
      { label: "C", name: "chanve matt" },
      { label: "N", name: "Nero marquinia" },
      { label: "C", name: "Caraganna" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-7.jpg",
      "gallery-13.jpg",
      "gallery-2.jpg",
      "gallery-8.jpg",
      "gallery-14.jpg",
      "gallery-3.jpg",
      "gallery-9.jpg",
      "gallery-15.jpg",
      "gallery-4.jpg",
      "gallery-10.jpg",
      "gallery-5.jpg",
      "gallery-11.jpg",
      "gallery-6.jpg",
      "gallery-12.jpg",
      "project5-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project6: {
    title: "Project 06 — Tunis, Tunisie",
    description: `
      Une cuisine au style contemporain et sophistiqué, dominée par des tons 
sombres et profonds. Les façades gris mates apportent élégance et sobriété, 
tandis que le grès aux larges veinures marbrées habille le plan de travail et la 
crédence avec caractère.
L'îlot aux formes arrondies devient une pièce centrale sculpturale, adoucie par 
ses lignes fluides. Les touches de finition, comme la robinetterie cuivrée et 
l'éclairage discret, viennent réchauffer l'ensemble et créer une ambiance à la 
fois luxueuse et apaisante. 
    `,
    finishes: [
      { label: "G", name: "Gris matt" },
      { label: "G", name: "gres MARMI MAXFINE VOGUE" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-7.jpg",
      "gallery-2.jpg",
      "gallery-8.jpg",
      "gallery-3.jpg",
      "gallery-9.jpg",
      "gallery-4.jpg",
      "gallery-10.jpg",
      "gallery-5.jpg",
      "gallery-11.jpg",
      "gallery-6.jpg",
      "project6-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project7: {
    title: "Project 07 — Tunis, Tunisie",
    description: `
Une cuisine très lumineuse, ouverte sur l'espace de vie, tout en le structurant 
avec un îlot central qui agit comme élément de séparation subtil et élégant.
Le bois, présent dans les finitions et certains volumes, apporte une chaleur 
naturelle qui équilibre la modernité des surfaces et crée une atmosphère 
conviviale et accueillante. L'ensemble offre une continuité harmonieuse entre 
fonctionnalité, confort et esthétique
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "N", name: "Nogaro" },
      { label: "Q", name: "quartz" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-7.jpg",
      "gallery-2.jpg",
      "gallery-8.jpg",
      "gallery-3.jpg",
      "gallery-9.jpg",
      "gallery-4.jpg",
      "gallery-10.jpg",
      "gallery-5.jpg",
      "gallery-11.jpg",
      "gallery-6.jpg",
      "project7-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project8: {
    title: "Project 08 — Tunis, Tunisie",
    description: `
Une cuisine originale, sublimée par l'éclat du grès “Royal Peacock” aux mille 
nuances de bleu et de vert, qui apporte une profondeur artistique et vibrante à 
l'espace. Les façades en bleu mat viennent adoucir ce véritable festin de 
couleurs, créant un équilibre élégant et apaisant.
Les colonnes en bois, quant à elles, rappellent davantage une nature sauvage 
et authentique, apportant chaleur et caractère, comme un lien direct avec 
l'extérieur. L'ensemble compose une atmosphère raffinée, à la fois 
contemporaine et organique, où chaque matériau dialogue avec harmonie.
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "A", name: "acrymatt bleu pastel" },
      { label: "B", name: "bois chene brown" },
      { label: "G", name: "gres Royal Peacock" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-7.jpg",
      "gallery-13.jpg",
      "gallery-2.jpg",
      "gallery-8.jpg",
      "gallery-14.jpg",
      "gallery-3.jpg",
      "gallery-9.jpg",
      "gallery-15.jpg",
      "gallery-4.jpg",
      "gallery-10.jpg",
      "gallery-5.jpg",
      "gallery-11.jpg",
      "gallery-6.jpg",
      "gallery-12.jpg",
      "project8-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project9: {
    title: "Project 09 - Sousse , Tunisie",
    description: `
Cette cuisine en forme de L, entièrement noire, incarne le luxe et la 
sophistication. Les façades en MDF Acrymat noir, agrémentées de quelques 
éléments vitrés et illuminées par des touches de LED, créent une ambiance 
élégante et contemporaine. 
L'îlot central est équipé d'une plaque à induction, parfaitement assortie à une 
hotte escamotable qui se fond discrètement dans le design.
À côté, une friteuse encastrée complète cet espace de cuisson avec une 
intégration soignée. 
Le four, le micro-ondes, le tiroir chauffant, et la cave à vin sont disposés de 
manière horizontale et alignée, leur finition en noir brillant permettant de les 
intégrer parfaitement dans l'ensemble du décor.
Le choix du grès noir désir, avec ses veines dorées, ajoute une touche de 
charme et accentue le caractère luxueux de la cuisine, transformant l'espace 
en un lieu de sophistication et de raffinement.
    `,
    finishes: [
      { label: "N", name: "noir matt" },
      { label: "V", name: "vitré fumé marron" },
      { label: "N", name: "noir desir grés" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-18.jpg",
      "gallery-7.jpg",
      "gallery-19.jpg",
      "gallery-13.jpg",
      "gallery-20.jpg",
      "gallery-2.jpg",
      "gallery-8.jpg",
      "gallery-14.jpg",
      "gallery-3.jpg",
      "gallery-9.jpg",
      "gallery-15.jpg",
      "gallery-4.jpg",
      "gallery-10.jpg",
      "gallery-5.jpg",
      "gallery-11.jpg",
      "gallery-6.jpg",
      "gallery-12.jpg",
      "gallery-13.jpg",
      "gallery-14.jpg",
      "gallery-16.jpg",
      "gallery-17.jpg",
      "project9-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project10: {
    title: "Project 10 - Tunis , Tunisie",
    description: `
Cette cuisine linéaire, aux façades en MDF Acrymat noir, combine simplicité et 
élégance moderne. L’îlot central accueille une plaque de cuisson et un évier 
encastré en grès, tandis que deux colonnes offrent des espaces de rangement 
astucieux, avec un réfrigérateur et un four encastrés. La hotte en forme de L, 
noire, s’intègre parfaitement à l’ensemble. Le contraste entre le noir profond et 
la blancheur du plan de travail illumine la cuisine, créant une atmosphère chic 
et lumineuse.
    `,
    finishes: [
      { label: "N", name: "noir matt" },
      { label: "V", name: "vitré fumé marron" },
      { label: "A", name: "absolute white grés" },
    ],
  },
   project11: {
    title: "Project 11 - Megrine , Tunisie",
    description: `
Cette cuisine associe HPL noir Ardesia et HPL bois pour une esthétique 
élégante et contemporaine, sublimée par un plan de travail en grès Calacatta 
brillant et un évier en grès avec égouttoir mobile. L’aménagement intègre deux 
réfrigérateurs encastrés combinés, une colonne vitrée à cadre aluminium noir 
et verre fumé, ainsi que des tiroirs à l’anglaise en gris charbon. Une porte 
invisible en HPL, fine et discrète, complète l’ensemble, tandis que les 
accessoires porte-épices, range- couverts Ambia-Line et poubelle à 4 
compartiments encastrée dans un meuble bas extractible optimisent le 
rangement et la fonctionnalité.
    `,
    finishes: [
      { label: "H", name: "hpl ardesia" },
      { label: "H", name: "hpl bois" },
      { label: "C", name: "calacatta brillant" },
    ],
  },
   project12: {
    title: "Project 12 - Bizerte , Tunisie",
    description: `
Cette cuisine en U marie harmonieusement équipements modernes et charme 
d’antan. Les façades laquées gris, agrémentées de fines moulures et de 
poignées rustiques, évoquent un style traditionnel, tandis que les étagères en 
bois et les niches à bouteilles ajoutent une touche authentique et pratique. Le 
plan de travail en grès de teinte crémeuse apporte une dimension moderne et 
minimaliste, créant 
un bel équilibre entre fonctionnalité contemporaine et esthétique vintage 
    `,
    finishes: [
      { label: "L", name: "laqué vert de gris" },
      { label: "A", name: "absolute white grés" },
    ],
  },
   project13: {
    title: "Project 13 - Tunis , Tunisie",
    description: `
Cette cuisine se distingue par ses façades en MDF Acrymatt Chanvre, 
associées à des meubles hauts en mdf str bois chêne Dark, une Gola noire et 
des plinthes noires. Le plan de travail en quartz Calacatta Victory est 
accompagné d’un évier en quartz avec égouttoir fixe. L’ensemble est rythmé 
par des meubles hauts à double hauteur et double profondeur, tandis que l’îlot 
central avec table attenante crée un espace convivial et fonctionnel. Un lave
vaisselle apparent complète cet aménagement contemporain. 
    `,
    finishes: [
      { label: "A", name: "acrymatt chanvre" },
      { label: "C", name: "chêne dark" },
      { label: "C", name: "calacatta victory quartz" },
    ],
  },
   project14: {
    title: "Project 14 - Tunis , Tunisie",
    description: `
Cette cuisine en L, agrémentée d'un îlot central, se distingue par ses façades 
en acrymat gris charbon foncé, offrant une élégance intemporelle. Pour assurer 
une continuité visuelle harmonieuse, nous avons choisi un plan de travail en 
quartz Charcoal Soapstone de la même couleur que les façades avec des vines 
blanches très discrete, créant ainsi un effet de fusion dans le décor.
Une touche de bois MDF stratifié en chêne brown a été ajoutée, apportant une 
note de fraîcheur et de chaleur à l'ensemble de la cuisine.
    `,
    finishes: [
      { label: "G", name: "gris charbon" },
      { label: "C", name: "chêne brown" },
      { label: "V", name: "vitré fumé marron" },
       { label: "C", name: "charcoal Soapstone quartz" },
    ],
  },
   project15: {
    title: "Project 15 - Tunis , Tunisie",
    description: `
Cette cuisine en L, généreuse et ouverte, séduira les passionnés de matériaux 
nobles. Les façades en MDF stratifié noyer naturel apportent une chaleur et une 
authenticité inégalées, parfaitement mises en valeur par le contraste élégant 
avec un grès NERO DAMASCATO noir aux veines dorées, qui habille à la fois le 
plan de travail et l’îlot central.
Les meubles hauts vitrés, flottant avec légèreté sur un large mur de crédence 
en grès, s'ouvrent et se referment d'un simple clic grâce au mécanisme Servo
Drive imaginé par Blum, ajoutant une touche aérienne et moderne à l’ensemble.
Des accessoires subtils, comme le porte-épices et le porte-pain, sont 
astucieusement intégrés, tandis qu’une porte invisible, discrètement 
dissimulée, mène vers un autre espace, soulignant l'ingéniosité et l'élégance 
fonctionnelle de cette cuisine. 
    `,
    finishes: [
      { label: "F", name: "façade noyer" },
      { label: "V", name: "vitré fumé marron" },
      { label: "N", name: "nero damascato grès" },
    ],
  },
   project16: {
    title: "Project 16 - Hammamet , Tunisie",
    description: `
Cette cuisine ton sur ton associe des façades en MDF Acrylgloss Chanvre, en 
finition lisse et striée, sublimées par un éclairage LED sous meubles, sous la 
Gola et sous l’îlot. Les façades vitrées à cadre aluminium noir et verre fumé 
marron apportent profondeur et élégance, tandis que les rangements sur 
mesure permettent d’intégrer harmonieusement les équipements de la cliente. 
Le quartz crèmeux brillant accentue le ton sur ton et reflète délicatement la 
lumière, créant une ambiance raffinée et lumineuse.
    `,
    finishes: [
      { label: "A", name: "acrygloss chanvre" },
      { label: "V", name: "vitré fumé marron" },
      { label: "A", name: "artemis quartz" },
    ],
  },
     project17: {
    title: "Project 17 - Mornag , Tunisie",
    description: `
Cuisine élégante aux contrastes raffinés, associant colonnes blanches, plan de 
travail en grès blanc et crédence noire veinée de blanc. Les meubles hauts en 
MDF stratifié noyer apportent chaleur et caractère, sublimés par une vitrine en 
verre fumé intégrant une niche TV sur mesure. 
Un îlot spacieux avec chaises hautes complète l’ensemble, accompagné de 
solutions fonctionnelles sur mesure : porte-épices, poubelle sous évier, ainsi 
que deux micro-onde avec deux tiroirs chauffe-plats positionnés en dessous, 
et un four, disposés côte à côte, parfaitement alignés horizontalement et 
centrés pour une composition harmonieuse. 
    `,
    finishes: [
      { label: "N", name: "noir matt" },
      { label: "V", name: "vitré fumé marron" },
      { label: "N", name: "noir désir grès" },
    ],
  },
       project18: {
    title: "Project 18 - Tunis , Tunisie",
    description: `
Cette cuisine en L se distingue par ses façades en MDF acrygloss blanc pour 
une brillance élégante, complétées par un plan de travail et un îlot central 
blancs. La crédence en grès Reale Oceano bleu ajoute un contraste raffiné, 
tandis que l’îlot est réchauffé par une surface en MDF stratifié chêne beige. Le 
tramage discret du meuble haut basculant renforce l’aspect fonctionnel tout en 
apportant une touche de sophistication à l’ensemble.
    `,
    finishes: [
      { label: "F", name: "facade acrygloss blanc" },
      { label: "C", name: "chêne beige" },
      { label: "A", name: "absolute white grès" },
       { label: "R", name: "reale oceano grès" },
      
    ],
  },
         project19: {
    title: "Project 19 - Sfax , Tunisie",
    description: `
Cuisine très moderne et lumineuse, sublimée par des façades Acrygloss blanc 
et des façades en miroir bronze, créant un jeu de reflets élégant. Le grès 
Magellano, avec ses grandes veines et ses motifs marquants, apporte du 
caractère et une forte présence à la cuisine. Le plan de travail se prolonge en 
double hauteur avec une table en verre. L’îlot intègre un multiprise ascenseur 
parfaitement dissimulé, tandis que la Gola et la plinthe noires soulignent les 
lignes épurées. Une colonne vitrée en verre fumé marron complète l’ensemble 
avec une touche de sophistication et de brillance. 
    `,
    finishes: [
      { label: "A", name: "acrygloosss blanc" },
      { label: "M", name: "miroir bronze" },
      { label: "V", name: "vitré fumé marron" },
       { label: "M", name: "magellano grès" },
    ],
  },
    project20: {
    title: "Project 20 - Tunis , Tunisie",
    description: `
Cuisine élégante associant façades blanc brillant et Gola gris, sublimées par un 
plan de travail en grès Absolute White. Les meubles hauts en MDF stratifié 
finition chêne Honey apportent une touche chaleureuse et naturelle. Ils sont 
équipés d’un mécanisme HF Blum, permettant l’ouverture facile et simultanée 
des deux façades superposées. La cuisine intègre également un porte
bouteilles pour une organisation fonctionnelle et élégante.
    `,
    finishes: [
      { label: "B", name: "blanc brillant" },
      { label: "C", name: "chêne honey" },
    ],
  },
   project21: {
    title: "Project 21 - Tunis , Tunisie",
    description: `
Cette cuisine allie praticité et élégance. Les façades en Acrymatt gris blanc 
apportent douceur et modernité, tandis que la hauteur sous plafond a permis 
de créer une trame régulière en Acrygloss blanc, renforçant la sensation de 
hauteur et d’élégance de l’espace.
Le plan de travail en grès Calacatta blanc, marqué par de délicates veines 
grises, apporte une touche raffinée à l’ensemble. La cuisine intègre également 
des accessoires fonctionnels, notamment un panier à pain et un monte-plat 
dissimulé, soigneusement camouflé par un habillage en MDF identique aux 
façades.
    `,
    finishes: [
      { label: "G", name: "gris matt" },
      { label: "B", name: "blanc brillant" },
      { label: "V", name: "vitré fumé marron" },
       { label: "C", name: "calacatta grès" },
    ],
  },
};
/*------------------------------Dressings-------------------------------------*/
export const projectsDressings = {
  project1: {
    title: "Project 01 — Penthouse, Tunis",
    description: `
Une chambre dressing pensée comme un espace élégant et fonctionnel, intégrant une coiffeuse avec
harmonie. La composition alterne entre des modules de dressing aux façades vitrées, subtilement éclairées
par un éclairage LED pour apporter légèreté et raffinement, et d'autres sans façades, dotés de fonds miroirs
qui amplifient la profondeur de l'espace. Des tiroirs viennent compléter l'ensemble, offrant des solutions de
rangement pratiques et discrètes.
    `,
    finishes: [
      { label: "B", name: "bois castello" },
      { label: "M", name: "miroir bronze" },
    ],
  },
  project2: {
    title: "Project 02 — Villa d'Été, Sfax",
    description: `
Un dressing intégré qui s'inscrit avec élégance dans l'architecture de la chambre, jouant
sur un équilibre subtil entre sobriété et transparence. Les façades pleines, aux lignes
épurées, structurent l'ensemble et dissimulent le rangement avec discrétion, tandis que
des colonnes vitrées viennent rythmer la composition. Celles-ci, délicatement éclairées
par des LED intégrées, mettent en valeur les pièces exposées et apportent une touche
de légèreté visuelle.
Au centre, une coiffeuse en bois foncé s'intègre harmonieusement dans la continuité du
dressing, avec un miroir qui prolonge la perspective et accentue la sensation de
profondeur. Les niches ouvertes et les tiroirs offrent un rangement fonctionnel et
organisé, sans alourdir l'esthétique globale.
L'ensemble est sublimé par un travail d'éclairage soigné, notamment au plafond avec
un jeu de LED indirectes, qui enveloppe l'espace d'une ambiance chaleureuse et
contemporaine.

    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "B", name: "bois caraganna" },
    ],
  },
  project3: {
    title: "Project 03 — Villa Duplex, Tunis",
    description: `
Un dressing au design épuré et contemporain, où la sobriété des façades pleines se marie avec
des touches de transparence soigneusement mises en scène. Les portes, parfaitement alignées,
créent un effet de mur intégré, discret et élégant.
Au centre, une colonne vitrée vient rythmer l'ensemble : mise en valeur par un éclairage LED
vertical, elle transforme les étagères en véritable vitrine, apportant chaleur et profondeur grâce
à son intérieur bois. Ce jeu de lumière souligne les volumes et crée un contraste subtil avec la
douceur des tons clairs.
La coiffeuse, intégrée dans la continuité, prolonge cette écriture minimaliste avec ses lignes
fines et ses rangements discrets. L'éclairage indirect, présent en soubassement et en périphérie,
enveloppe l'espace d'une ambiance douce et raffinée, renforçant le caractère à la fois
fonctionnel et haut de gamme .


    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "V", name: "vitre bronze" },
    ],
  },
  project4: {
    title: "Project 04 — Villa Privée, Tunis",
    description: `
Un dressing au design doux et contemporain, marqué par une esthétique épurée et lumineuse. Les
façades en bois clair, aux lignes verticales discrètes, apportent une sensation de chaleur tout en
conservant une grande sobriété. Les poignées fines viennent souligner la verticalité et renforcer
l'élégance de l'ensemble.
Sur le côté, une colonne vitrée s'intègre subtilement dans la composition, créant une rupture
visuelle légère. Elle permet d'exposer certains éléments tout en ajoutant de la profondeur et du
rythme au dressing.
Au centre de l'espace, l'îlot joue un rôle structurant et fonctionnel. Son design minimaliste, aux
lignes franches et aux teintes claires, s'inscrit parfaitement dans la continuité du dressing. Il est
équipé de tiroirs généreux, organisés avec des séparations intérieures dédiées aux accessoires :
montres, bijoux, lunettes ou petits objets du quotidien. Cette organisation permet un rangement
précis, pratique et facilement accessible, tout en valorisant chaque élément.
L'ensemble crée un espace à la fois élégant, fluide et parfaitement optimisé, où chaque détail est
pensé pour allier esthétique et fonctionnalité
    `,
    finishes: [{ label: "C", name: "Chene light" }],
  },
  project5: {
    title: "Project 05 — Appartement, Tunis",
    description: `
Strié laqué ecru - miroir bronze - 
Ce dressing se distingue par une esthétique contemporaine et épurée, sublimée par une palette
de teintes neutres où se mêlent harmonieusement le beige et le bois Caraganna. La
composition intègre des panneaux striés à l'effet subtilement ondulé, apportant du rythme et
une texture raffinée à l'ensemble.
Au centre, un large miroir bronze, élégamment encadré de bois Caraganna, structure l'espace
tout en accentuant la profondeur et la luminosité. L'éclairage suspendu circulaire, en finition
dorée, vient parfaire la composition en ajoutant une touche sophistiquée et chaleureuse.
L'ensemble dégage une impression d'ordre, de sobriété et de raffinement, où chaque élément
est pensé pour allier esthétique et élégance intemporelle
    `,
    finishes: [
      { label: "S", name: "Strié laqué ecru" },
      { label: "M", name: "miroir bronze" },
    ],
  },
   project6: {
    title: "Project 06 — Villa Privée, Tunis",
    description: `
Ce dressing associe la chaleur du bois Caraganna à l’élégance du verre fumé 
marron, créant un ensemble à la fois chaleureux, contemporain et raffiné.
Les façades vitrées intègrent un éclairage LED avec capteur, apportant une 
lumière subtile et fonctionnelle dès l’ouverture des espaces de rangement.Au 
centre du dressing, une coiffeuse a été directement intégrée à l’aménagement. 
Son fond entièrement habillé d’un miroir, du sol au plafond, accentue la 
profondeur de l’espace tout en apportant une touche sophistiquée. Un tiroir 
complète cet espace pensé pour allier esthétique, fonctionnalité et confort au 
quotidien.
    `,
    finishes: [
      { label: "C", name: "Caraganna" },
      { label: "V", name: " verre fumé marron" },
    ],
  },
   project7: {
    title: "Project 07 — Villa Privée, Tunis",
    description: `
Ce dressing associe élégance et fonctionnalité à travers un aménagement 
entièrement pensé sur mesure.
Les façades en finition chanvre mat apportent une esthétique douce et 
contemporaine, tandis qu’un espace vitré dédié aux sacs à main est sublimé 
par un éclairage LED intégré, mettant en valeur chaque pièce.
Au centre de l’aménagement, une coiffeuse intégrée complète l’ensemble, 
accompagnée d’un tiroir spécialement conçu pour organiser les accessoires. 
Un agencement qui conjugue rangement, mise en valeur et confort au 
quotidien. 
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "V", name: " verre fumé marron" },
    ],
  },
    project8: {
    title: "Project 08 — Villa Privée, Tunis",
    description: `
Ce dressing mise sur une esthétique épurée et intemporelle, avec des façades 
en blanc mat qui apportent luminosité et douceur à l’espace. Les façades miroir 
viennent rythmer l’ensemble tout en accentuant visuellement la profondeur de 
la pièce. De discrètes poignées noires de 120 cm de hauteur soulignent les 
lignes du mobilier et apportent une touche graphique contemporaine.
Un aménagement sobre et élégant, pensé pour offrir un équilibre entre 
fonctionnalité, simplicité et raffinement.
    `,
    finishes: [
      { label: "B", name: "blanc matt" },
      { label: "M", name: "miroir" },
    ],
  },
    project9: {
    title: "Project 09 — Villa Privée, Tunis",
    description: `
Ce dressing associe la douceur des façades en chanvre mat à l’élégance du 
miroir bronze, créant une atmosphère chaleureuse et sophistiquée.
Au centre de l’espace, un îlot sur mesure offre des rangements dédiés aux 
accessoires, avec des séparations vitrées permettant de les organiser et de les 
garder parfaitement visibles. Des compartiments vitrés en partie haute viennent 
compléter cet aménagement tout en apportant une dimension plus élégante et 
décorative. 
Une banquette intégrée vient naturellement s’insérer dans l’ensemble, offrant 
un espace pratique pour s’asseoir et facilitant le quotidien
    `,
    finishes: [
      { label: "M", name: "miroir bronze" },
      { label: "C", name: "chanvre matt" },
    ],
  },
     project10: {
    title: "Project 10 — Villa d'Été , Mornag",
    description: `
Ce dressing joue sur l’association raffinée du verre fumé marron et du miroir 
bronze, créant une atmosphère chaleureuse, élégante et contemporaine.
Les tiroirs intérieurs dotés de façades vitrées permettent de visualiser 
facilement les accessoires et les effets personnels tout en les protégeant.
Pour une fonctionnalité optimale, une table à repasser encastrée a été intégrée 
directement dans l’aménagement, offrant une solution discrète et pratique sans 
compromettre l’esthétique du dressing. Un agencement sur mesure où chaque 
détail est pensé pour allier élégance, organisation et praticité au quotidien. 
    `,
    finishes: [
      { label: "M", name: "miroir bronze" },
      { label: "V", name: "verre fumé marron" },
    ],
  },
};
/*------------------------------Project international-------------------------------------*/
export const projectsCuisinesIntData = {
  project1: {
    title: "Project 01 - île de France , France",
    description: `
    Une cuisine au design épuré, où la douceur des teintes claires s'équilibre 
avec la profondeur du bois. L'îlot central, à la fois fonctionnel et sculptural, 
devient le cœur convivial de l'espace.
Des accessoires discrets, tels que des tablettes coulissantes et des tiroirs 
à l'anglaise intégrés dans les colonnes, viennent enrichir l'ensemble en 
optimisant la fonctionnalité avec subtilité.
Les lignes minimalistes et l'éclairage délicat révèlent les matières avec 
finesse, créant une atmosphère chaleureuse, contemporaine et apaisante.
    `,
    finishes: [
      { label: "C", name: "chanvre Matt" },
      { label: "N", name: "nogaro" },
      { label: "Q", name: "quartz calacatta gold" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-9.jpg",
      "gallery-2.jpg",
      "gallery-3.jpg",
      "gallery-4.jpg",
      "gallery-5.jpg",
      "gallery-6.jpg",
      "gallery-7.jpg",
      "gallery-8.jpg",
      "project1-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project2: {
    title: "Project 02 - Nice, France",
    description: `
Une cuisine au caractère affirmé, où le bois chaleureux enveloppe l'espace 
avec élégance. Le grès aux nuances rosées, presque minérales, capte la 
lumière et apporte une dimension artistique et singulière. 
Les étagères rétroéclairées soulignent la profondeur des matières, tandis 
que les lignes épurées structurent l'ensemble avec finesse. Une 
composition à la fois contemporaine et sensorielle, où chaque détail 
participe à une atmosphère intime et raffinée.
    `,
    finishes: [
      { label: "N", name: "nogaro" },
      { label: "G", name: "gres Onice malaga" },
    ],
  },
  project3: {
    title: "Project 03 - île de France , France",
    description: `
Une cuisine à l'élégance graphique, où le contraste entre les façades blanches 
et le bois profond structure l'espace avec justesse. Le plan de travail clair, aux 
veines subtiles, apporte douceur et luminosité.
Les éléments boisés, ponctués de détails ajourés et rétroéclairés, insufflent 
rythme et caractère, tandis que les lignes épurées renforcent l'harmonie 
d'ensemble. Une composition contemporaine, à la fois sobre, chaleureuse et 
parfaitement équilibrée
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "C", name: "caraganna" },
      { label: "Q", name: "quartz calacatta gold" },
    ],
  },
  project4: {
    title: "Project 04 - île de France , France",
    description: `
cuisine bleu nuit decrire brievement
Cuisine moderne au style épuré, dominée par des meubles bleu nuit mats. Le 
plan de travail clair et la crédence beige apportent du contraste et de la 
chaleur. L'éclairage sous les meubles hauts crée une ambiance douce, tandis 
que les lignes minimalistes et les appareils intégrés renforcent l'aspect 
contemporain et fonctionnel
    `,
    finishes: [
      { label: "B", name: "Bleu nuit matt" },
      { label: "G", name: "gres diamond cream" },
    ],
  },
  project5: {
    title: "Project 05 - île de France , France",
    description: `
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "C", name: "chene brown" },
    ],
  },
  project6: {
    title: "Project 06 - île de France , France",
    description: `
Une cuisine au caractère affirmé, où le noir mat enveloppe l'espace avec 
élégance et sobriété. Le grès effet travertin, doux et minéral, éclaire l'ensemble 
d'une chaleur naturelle. En hauteur, les façades en miroir bronze captent et 
diffusent la lumière, tandis que les meubles vitrés, délicatement éclairés, 
révèlent les objets comme en vitrine. Une composition raffinée, entre 
profondeur, lumière et matière.
    `,
    finishes: [
      { label: "N", name: "noir matt" },
      { label: "M", name: "miroir bronze" },
      { label: "G", name: "gres travertin" },
    ],
  },
  project7: {
    title: "Project 07 - île de France , France",
    description: `
Une cuisine baignée de lumière, où le blanc s'exprime dans une pureté 
élégante et intemporelle. Les lignes épurées dessinent un espace 
minimaliste, calme et raffiné. Au centre, l'îlot devient une pièce légère et 
aérienne grâce à son meuble vitré, qui apporte transparence et subtil jeu 
de volumes. En contraste subtil, un coin café en bois vient réchauffer 
l'ensemble, insufflant une note naturelle et conviviale qui dialogue 
harmonieusement avec la blancheur dominante
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "C", name: "chene brown" },
      { label: "C", name: "calacatta gold" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-6.jpg",
      "gallery-2.jpg",
      "gallery-3.jpg",
      "gallery-4.jpg",
      "gallery-5.jpg",
      "project7-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project8: {
    title: "Project 08 - île de France , France",
    description: `
Cuisine aux lignes épurées, baignée d'une lumière douce qui souligne 
l'alliance du bois chaleureux et des surfaces claires. Tout y est calme, 
précis, presque silencieux.
Le meuble TV, discret et suspendu, s'efface dans l'espace, tandis qu'une 
colonne lumineuse expose quelques objets comme des œuvres choisies.
Le coin lecture, niché dans le bois, devient un refuge intime — un lieu 
simple et apaisant où le temps semble ralentir.
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "C", name: "chene rouge" },
      { label: "G", name: "gres bianco lasa" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-6.jpg",
      "gallery-2.jpg",
      "gallery-7.jpg",
      "gallery-3.jpg",
      "gallery-8.jpg",
      "gallery-4.jpg",
      "gallery-9.jpg",
      "gallery-5.jpg",
      "gallery-10.jpg",
      "project8-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project9: {
    title: "Project 09 - île de France , France",
    description: `
Cette cuisine présente un style moderne et épuré, avec des lignes nettes 
et des matériaux élégants. Les meubles combinent un bois chaleureux et 
des finitions claires, contrastés par un plan de travail noir brillant. Un 
éclairage suspendu linéaire apporte une touche contemporaine, tandis que 
les panneaux verticaux texturés structurent l'espace. L'ensemble est 
lumineux, raffiné et fonctionnel. 
    `,
    finishes: [
      { label: "C", name: "chanvre brillant" },
      { label: "C", name: "chene brown noir desir" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-5.jpg",
      "gallery-2.jpg",
      "gallery-3.jpg",
      "gallery-4.jpg",
      "project9-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project10: {
    title: "Project 10  - île de France , France",
    description: `
Cette cuisine adopte un style contemporain et épuré, avec des façades 
claires aux lignes sobres et sans poignées apparentes. L'îlot central en 
pierre marbrée constitue un élément structurant, à la fois esthétique et 
fonctionnel, intégrant des rangements discrets. La crédence assortie, 
rétroéclairée, met en valeur les veines naturelles du matériau et apporte 
de la profondeur à l'ensemble. Les éléments vitrés en hauteur ajoutent une 
touche de légèreté tout en offrant un espace de rangement visible et 
organisé.
    `,
    finishes: [
      { label: "C", name: "chanvre matt" },
      { label: "G", name: "gres magellano" },
      { label: "C", name: "chene brown" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-5.jpg",
      "gallery-2.jpg",
      "gallery-3.jpg",
      "gallery-4.jpg",
      "gallery-5.jpg",
      "gallery-6.jpg",
      "gallery-7.jpg",
      "project10-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project11: {
    title: "Project 11 - île de France , France",
    description: `
Un espace ouvert et harmonieux reliant une cuisine fonctionnelle à un coin 
repas convivial, structuré par un meuble de service central. L’aménagement se 
prolonge naturellement avec un meuble TV assorti et se termine par une 
élégante colonne vitrée, créant une transition fluide vers le salon. 
Pour préserver une atmosphère douce et lumineuse, nous avons privilégié des 
façades en grège clair associées à un bois de chêne beige clair. Cette 
combinaison de teintes permet de minimiser les contrastes tout en apportant 
chaleur, élégance et cohérence à l’ensemble de l’espace. 
    `,
    finishes: [
      { label: "C", name: "chanvre brillant" },
      { label: "C", name: "chêne beige" },
      { label: "Q", name: "Quartz artemis" },
      { label: "G", name: "Grès diamond cream" },
    ],
    gallery: [
      "gallery-1.jpg",
      "gallery-5.jpg",
      "gallery-2.jpg",
      "gallery-3.jpg",
      "gallery-4.jpg",
      "gallery-5.jpg",
      "gallery-6.jpg",
      "gallery-7.jpg",
      "gallery-8.jpg",
      "gallery-9.jpg",
      "gallery-10.jpg",
      "project11-couverture.jpg",
      "L.jpg",
      "M.jpg",
    ],
  },
  project12: {
    title: "Project 12 - île de France , France",
    description: `
Une cuisine optimisée en forme de U, conçue en double profondeur afin de 
maximiser les capacités de rangement tout en garantissant un confort 
d’utilisation au quotidien. Le comptoir-bar en retour vient structurer l’espace et 
est enrichi par un meuble bas vitré, offrant à la fois un accès rapide à la verrerie 
et une touche décorative raffinée. 
L’intégration architecturale a été soigneusement étudiée grâce au camouflage 
de la gaine technique, rendu possible par la continuité de l’habillage mural 
réalisé dans les mêmes matériaux que les façades. Cette approche permet de 
préserver l’harmonie visuelle de l’ensemble et de renforcer la sensation d’un 
espace épuré. 
La palette de couleurs claires est réchauffée par la présence d’un bois chêne 
brun et d’un plan de travail effet travertin. Inspirés de la beauté intemporelle de 
la nature, ces matériaux apportent authenticité, élégance et chaleur à cet 
aménagement contemporain. 
    `,
    finishes: [
      { label: "C", name: "chanvre brillant" },
      { label: "C", name: "chêne brown" },
      { label: "G", name: "Grès travertin fondovalle" },
    ],
  },
   project13: {
    title: "Project 13 - île de France , France",
    description: `
Un espace ouvert et harmonieux reliant une cuisine fonctionnelle à un coin 
repas convivial, structuré par un meuble de service central. L’aménagement se 
prolonge naturellement avec un meuble TV assorti et se termine par une 
élégante colonne vitrée, créant une transition fluide vers le salon. 
Pour préserver une atmosphère douce et lumineuse, nous avons privilégié des 
façades en grège clair associées à un bois de chêne beige clair. Cette 
combinaison de teintes permet de minimiser les contrastes tout en apportant 
chaleur, élégance et cohérence à l’ensemble de l’espace.
    `,
    finishes: [
      { label: "C", name: "chanvre brillant" },
      { label: "C", name: "chêne beige" },
      { label: "A", name: "artemis quartz" },
      { label: "D", name: "diamond cream  grès" },
    ],
  },
};
